// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1syml","disabled":"FileBtn_disabled__8kPzb","warn":"FileBtn_warn__1oL6j","fade":"FileBtn_fade__QJUlp"};